export const SOURCED = "SOURCED";
export const APPLIED = "APPLIED";
export const SHORTLISTED = "SHORTLISTED";
export const AI_INTERVIEW = "AI_INTERVIEW";
export const NOT_SHORTLISTED = "NOT_SHORTLISTED";
export const INPERSON_INTERVIEW = "INPERSON_INTERVIEW";
export const HIRED = "HIRED";
export const REJECTED = "REJECTED";
export const CODING_INTERVIEW_SUBMITTED = "CODING_INTERVIEW_SUBMITTED";
